export enum ObjectReturnModeEnum {
  LIGHT = "LIGHT",
  FULL = "FULL",
}
